/**
 * @generated SignedSource<<f4de0111b0006a82e527fc2add752569>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_project$data = {
  readonly key: string;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_project";
};
export type groupTableBody_nativeIssueTable_project$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupTableBody_nativeIssueTable_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9172a5a0fde9cea9f3863762a614cb99";

export default node;
